import { pdf } from "@react-pdf/renderer";
import TimesheetReportPDF from "presentation/components/Timesheet/TimesheetReportPDF";
import { useTimesheetReportsByEmployee } from "presentation/hooks/use-query-timesheet-report";
import { useTimesheetUploader } from "presentation/hooks/useTimesheetUploader";
import { useEmployeesByFilter } from "presentation/hooks/use-query-employees";
import { useDocumentTypeByFilter } from "presentation/hooks/use-query-document-type";
import { DocumentTypeInputFilter } from "domain/models/document-type-input-filter";
import { useDocumentByFilter } from "presentation/hooks/use-query-document";
import { DocumentInputFilter } from "domain/models/document-input-filter";
import { Employee } from "domain/entities/employee";

export const useTimesheetPdfGenerator = (timesheetId?: string, userEmployee?: Employee) => {
    const { processSingleReport, deleteDocumentMutation } = useTimesheetUploader();
    const { refetch: refetchReportData } = useTimesheetReportsByEmployee(timesheetId ?? "");
    const { data: employeeData } = useEmployeesByFilter({
        email: userEmployee?.emailAddress ?? "",
    });
    const { data: docTypeData } = useDocumentTypeByFilter({
        limit: 1,
        name: "Mapa de Horas",
    } as DocumentTypeInputFilter);

    const { data: existingDocuments } = useDocumentByFilter(
        {
            employeeId: userEmployee?.id,
            documentTypeId: docTypeData?.data?.[0]?.id,
            source: "other",
            limit: 100,
        } as DocumentInputFilter,
        { enabled: !!userEmployee?.id && !!docTypeData?.data?.[0]?.id }
    );

    const uploadPdfInBackground = async () => {
        try {
            const { data: latestReportResponse } = await refetchReportData();
            const report = latestReportResponse?.data;
            const employee = employeeData?.data?.[0] ?? userEmployee;
            const docTypeId = docTypeData?.data?.[0]?.id;

            if (!report || !employee || !docTypeId) return;

            const blob = await pdf(
                <TimesheetReportPDF
                    data={report}
                    isSuportService={employee.isSuportService ?? false}
                />
            ).toBlob();

            if (existingDocuments?.data) {
                for (const doc of existingDocuments.data) {
                    await deleteDocumentMutation(doc);
                }
            }

            await processSingleReport({
                blob,
                report,
                employee,
                docTypeId,
            });
        } catch (pdfErr) {
            console.error("Erro ao gerar PDF em background:", pdfErr);
        }
    };

    return { uploadPdfInBackground };
};